class DGFIPError extends Error {
    constructor(msg, { status, statusText, options }) {
      super(msg);
      this.status = status;
      this.statusText = statusText;
      this.options = options||{};
    }
  }

export const createError = ({ status, statusText }, options) => {
    const error = new DGFIPError(statusText,  { status, statusText, options }); 
    return error;
};
export default createError;